/* En-tête : recherche et menu mobile fonctionnent nativement (details/summary) ; ce script ajoute seulement le confort. */
(() => {
  'use strict';
  const header = document.querySelector('[data-tsb-header]');
  const onScroll = () => { if (header) header.classList.toggle('is-scrolled', window.scrollY > 4); };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  const pops = () => document.querySelectorAll('details[data-tsb-pop][open], details.mobile-nav[open]');
  document.addEventListener('click', event => {
    pops().forEach(menu => { if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    pops().forEach(menu => { menu.open = false; const summary = menu.querySelector('summary'); if (summary) summary.focus(); });
  });
  document.querySelectorAll('details[data-tsb-pop]').forEach(menu => {
    const summary = menu.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
    menu.addEventListener('toggle', () => {
      if (summary) summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
      if (!menu.open) return;
      document.querySelectorAll('details[data-tsb-pop][open]').forEach(other => { if (other !== menu) other.open = false; });
      const field = menu.querySelector('input[type=search]');
      if (field) window.setTimeout(() => field.focus(), 60);
    });
  });
})();